import React, { useId } from "react";

export default function Switch({
    checked = false,
    onChange,
    label,
    id,
    disabled = false,
    className = "",
}) {
    const defaultId = useId();
    const switchId = id || defaultId;

    const handleClick = () => {
        if (disabled) return;
        if (onChange) onChange(!checked);
    };

    return (
        <button
            id={switchId}
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={handleClick}
            className={`group inline-flex items-center gap-2.5 h-6 select-none cursor-pointer focus:outline-none ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
            } ${className}`}
        >
            <span
                className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out ${
                    checked ? "bg-primary" : "bg-gray-200 dark:bg-white/20"
                }`}
            >
                <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm ring-0 transition-transform duration-200 ease-in-out ${
                        checked ? "translate-x-4" : "translate-x-0.5"
                    }`}
                />
            </span>
            {label && (
                <span className="text-xs sm:text-sm font-normal text-foreground-light dark:text-foreground-dark group-hover:text-foreground-light/80 transition-colors">
                    {label}
                </span>
            )}
        </button>
    );
}
